import { Button, Card, Col, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import MessageFromServer from "../MessageFromServer";

function ErrorComunication({t, text, codeServer}){
    return (
        <Row>
            <Col xs="12" md={{span: 4, offset: 4}}>
                <Card className="shadow-sm">
                    <Card.Body>
                        <div className="text-center">
                            <label className="d-block">{text}</label>
                            {
                                codeServer && <MessageFromServer codeServer={codeServer}/>
                            }
                            <Button variant="link" block onClick={() => window.location.reload()}>Volver a intentar</Button>
                        </div>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default withTranslation()(ErrorComunication)